import {
  Box,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Spinner,
  Text,
} from '@chakra-ui/react';
import React from 'react';

import ErrorMessage from '@components/ErrorMessage';
import { IFormControl } from '@components/FormControl/FormControl.types';

const FormControlComponent: React.FC<IFormControl> = ({
  label,
  sublabel,
  help,
  extra,
  children,
  isOptional,
  colorExtra = 'font.ink',
  sizeExtra,
  isRequired,
  isLoading,
  isRow,
  isDetail,
  ...props
}): JSX.Element => {
  return (
    <FormControl
      {...(isRow && {
        display: 'grid',
        gridTemplateColumns: '150px 1fr',
      })}
      {...props}
    >
      <FormLabel
        {...(!label && { mb: '0' })}
        {...(isRow && {
          mb: '0',
          mt: isDetail ? '0' : '2',
        })}
      >
        <Flex align="center" w="full">
          {label}
          {isOptional && (
            <Text
              as="span"
              fontSize="xs"
              color="font.pencil"
              fontWeight="normal"
              ml="1"
            >
              (opsional)
            </Text>
          )}
          {isRequired && (
            <Text as="span" fontSize="xs" color="font.red" fontWeight="normal">
              *
            </Text>
          )}
          {isLoading && <Spinner size="xs" ml="2" />}
          {isDetail && (
            <Text ml="auto" justifySelf="flex-end">
              :
            </Text>
          )}
        </Flex>
        {sublabel && (
          <Text fontSize="xs" color="font.pencil" fontWeight="normal">
            {sublabel}
          </Text>
        )}
      </FormLabel>
      <Box flex="1">
        {children}
        {extra && (
          <FormHelperText color={colorExtra} fontSize={sizeExtra}>
            {extra}
          </FormHelperText>
        )}
        {help && <ErrorMessage message={String(help)} />}
      </Box>
    </FormControl>
  );
};

export default FormControlComponent;
